export const GET_PRODUCTS = "PRODUCTS/get";
export const FILTER_PRODUCTS = "PRODUCTS/filter";
export const SORT_PRODUCTS = "PRODUCTS/sort";
export const PAGINATE_PRODUCTS = "PRODUCTS/paginate";
